export default __webpack_public_path__ + "static/media/recorte_11.5e4460ad.JPG";